import React from "react";

const Login = () => {
  return (
    <div>
      <h1>welcome to user login page !!!!</h1>
    </div>
  );
};

export default Login;
